module.exports = __webpack_public_path__ + "images/8353bbda512b232cf0a3c04899b321bf.png";